const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const RoleApprovalQuery: any = {
    GetRoleApproversByRoleId: Backofficebff + '/v1/role-approval/role-approver/role',
    GetUserRoleApprovalRequests: Backofficebff + '/v1/role-approval/requests',
    GetPendingRoleRequestsByApprover: Backofficebff + '/v1/role-approval/requests/pending/approver',
    GetRequestableRoles: Backofficebff + '/v1/role-approval/requestable-roles',
    GetStaffInfo: Backofficebff + '/v1/role-approval/staff-info',
    GetMyActiveRequests: Backofficebff + '/v1/role-approval/my-requests/active',
    GetMyPastRequests: Backofficebff + '/v1/role-approval/my-requests/past',
};
